/** Shared admin page styling aligned with sidebar / dashboard. */

export const lato = 'Lato, sans-serif';

export const sectionLabelSx = {
  fontFamily: lato,
  fontSize: '0.65rem',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase' as const,
  color: 'text.disabled',
  lineHeight: 1.3,
};

export const sectionTitleSx = {
  fontFamily: lato,
  fontSize: '0.875rem',
  fontWeight: 600,
  color: 'text.primary',
};

export const pagePaperSx = {
  p: 2.5,
  borderRadius: 1.5,
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'rgba(0, 0, 0, 0.12)',
  boxShadow: 'none',
};

export const pageCardSx = {
  border: '1px solid',
  borderColor: 'rgba(0, 0, 0, 0.12)',
  borderRadius: 1.5,
  boxShadow: 'none',
};

/** Use with `variant="fullWidth"` so tabs span the full row evenly. */
export const pageTabsSx = {
  width: '100%',
  mb: 2.5,
  minHeight: 40,
  borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  '& .MuiTabs-flexContainer': {
    width: '100%',
  },
  '& .MuiTab-root': {
    fontFamily: lato,
    fontSize: { xs: '0.75rem', sm: '0.845rem' },
    fontWeight: 500,
    textTransform: 'none',
    minHeight: 40,
    py: 1,
    px: { xs: 0.5, sm: 1.5 },
    flex: 1,
    maxWidth: 'none',
    minWidth: 0,
    justifyContent: 'center',
    color: 'text.secondary',
    '&.Mui-selected': { color: 'primary.main', fontWeight: 600 },
  },
  '& .MuiTabs-indicator': {
    height: 3,
    borderRadius: '3px 3px 0 0',
  },
};

export const primaryButtonSx = {
  fontFamily: lato,
  fontSize: '0.845rem',
  fontWeight: 600,
  textTransform: 'none' as const,
  borderRadius: 1.5,
  boxShadow: 'none',
};

export const assetGridSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, 1fr)',
    md: 'repeat(3, 1fr)',
    lg: 'repeat(4, 1fr)',
    xl: 'repeat(5, 1fr)',
  },
  gap: 2.5,
};
